import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import DateRangeDropdown from '../../../../components/DateRangePicker';

import { changePeriod } from '../../actions/filters-actions';
import { filtersSelector } from '../../selectors';
import { initParams } from '../../configs';
import { MAX_SHOWED_PERIOD } from '../../configs/constants';

const { maxPeriod, maxDate, permissions } = initParams;

const PeriodDropdown = () => {
  const dispatch = useDispatch();
  const filters = useSelector(filtersSelector);

  const handleChange = (next) => dispatch(changePeriod(next));

  return (
    <DateRangeDropdown
      maxPeriod={maxPeriod}
      maxDateTo={maxDate ? new Date(maxDate) : undefined}
      maxShowedPeriod={MAX_SHOWED_PERIOD}
      currentPeriod={filters.period}
      dateFrom={filters.period_from_date}
      dateTo={filters.period_to_date}
      disabled={permissions.prospect || permissions.isFlexUser}
      onChange={handleChange}
    />
  );
};

export default PeriodDropdown;
